import {
  AgeIcon,
  GenderIcon,
  ProductTypeIcon,
  SizeIcon,
  SportIcon,
} from 'src/components/Icons/FilterIcons'

import type { VariantTypeCheckbox } from './types'

type VariantFilterType = {
  [key: string]: {
    type: VariantTypeCheckbox
    useAccordion: boolean
    defaultNumberOpts?: number
    Icon?: JSX.Element
  }
}

export const variantsFilter: VariantFilterType = {
  Tamanho: {
    type: 'default',
    useAccordion: false,
    Icon: <SizeIcon />,
    defaultNumberOpts: 5,
  },
  Promoção: {
    type: 'default',
    useAccordion: true,
  },
  Esporte: {
    type: 'default',
    useAccordion: true,
    Icon: <SportIcon />,
  },
  Entrega: {
    type: 'default',
    useAccordion: true,
  },
  'Tipo de montagem': {
    type: 'default',
    useAccordion: true,
  },
  'Tipo de produto': {
    type: 'default',
    useAccordion: true,
    Icon: <ProductTypeIcon />,
  },
  Gênero: {
    type: 'default',
    useAccordion: false,
    Icon: <GenderIcon />,
  },
  Idade: {
    type: 'default',
    useAccordion: false,
    Icon: <AgeIcon />,
  },
  'Cor predominante': {
    type: 'color',
    defaultNumberOpts: 10,
    useAccordion: true,
  },
  Avaliações: {
    type: 'starts',
    useAccordion: true,
  },
  Marca: {
    type: 'default',
    useAccordion: true,
  },
  Condições: {
    type: 'default',
    useAccordion: true,
  },
  'Marca própria': {
    type: 'default',
    useAccordion: true,
  },
  'Tipo de entrega': {
    useAccordion: false,
    type: 'default',
  },
  'Opções de entrega': {
    useAccordion: false,
    type: 'default',
  },
  'Loja de Retirada': {
    useAccordion: false,
    type: 'default',
  },
}

export const colorConfig: { [key: string]: string } = {
  cinza: '#848484',
  preto: '#000',
  prata: '#DADADA',
  roxo: '#AC45EB',
  laranja: '#FF600A',
  azul: '#007DBC',
  vermelho: '#EE0303',
  verde: '#2CAB0D',
  marrom: '#844F00',
  branco: '#FFFFFF',
  amarelo: '#F9D82C',
  rosa: '#E861CA',
  'n/a': '',
}
